'use client';

import './styles/@theme';

type NumberedBadgeProps = {
    numberToShow: number;
};

export const NumberedBadge = ({ numberToShow }: NumberedBadgeProps) => {
    return <div className="badge--numbered">{numberToShow}</div>;
};
